import { X, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export interface PollOption {
  text: string;
}

interface PollCreatorProps {
  question: string;
  onQuestionChange: (question: string) => void;
  options: PollOption[];
  onOptionsChange: (options: PollOption[]) => void;
  onRemove: () => void;
  disabled?: boolean;
}

export function PollCreator({ question, onQuestionChange, options, onOptionsChange, onRemove, disabled }: PollCreatorProps) {
  const updateOption = (index: number, text: string) => {
    const updated = [...options];
    updated[index] = { text };
    onOptionsChange(updated);
  };

  const addOption = () => {
    if (options.length < 4) {
      onOptionsChange([...options, { text: '' }]);
    }
  };

  const removeOption = (index: number) => {
    if (options.length > 2) {
      onOptionsChange(options.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="space-y-2 p-3 border border-border rounded-lg bg-muted/30">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">Enquete</span>
        <Button type="button" variant="ghost" size="sm" onClick={onRemove} disabled={disabled} className="h-6 w-6 p-0">
          <X className="h-4 w-4" />
        </Button>
      </div>
      <Input
        placeholder="Qual é a sua pergunta?"
        value={question}
        onChange={(e) => onQuestionChange(e.target.value)}
        disabled={disabled}
        className="text-sm font-medium"
        maxLength={200}
      />
      {options.map((opt, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            placeholder={`Opção ${i + 1}`}
            value={opt.text}
            onChange={(e) => updateOption(i, e.target.value)}
            disabled={disabled}
            className="text-sm"
            maxLength={100}
          />
          {options.length > 2 && (
            <Button type="button" variant="ghost" size="sm" onClick={() => removeOption(i)} disabled={disabled} className="h-8 w-8 p-0 shrink-0">
              <X className="h-3 w-3" />
            </Button>
          )}
        </div>
      ))}
      {options.length < 4 && (
        <Button type="button" variant="ghost" size="sm" onClick={addOption} disabled={disabled} className="w-full text-muted-foreground">
          <Plus className="h-4 w-4 mr-1" /> Adicionar opção
        </Button>
      )}
    </div>
  );
}
